// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__r-d37","insightsList":"newBusinessInsightsMenu_insightsList__3TE_c","active":"newBusinessInsightsMenu_active__33hu9"};